import api from "./axios";

export interface UserDto {
  id: number;
  firstName: string;
  lastName: string;
  middleName?: string;
  birthDate?: string;
  gender: string;
  phone: string;
  internalPhone?: string;
  emailCorporate: string;
  emailPersonal?: string;
  role: string;
  isActive: boolean;
  avatarUrl?: string | null;
  managerId?: number | null;
  dismissedAt?: string | null;
}

export interface CreateUserDto {
  firstName: string;
  lastName: string;
  middleName?: string;
  birthDate?: string;
  gender: string;
  phone: string;
  internalPhone?: string;
  emailCorporate: string;
  emailPersonal?: string;
  role: string;
  password: string;
  managerId?: number | null;
}

export interface UpdateUserDto extends Partial<CreateUserDto> {}

export const UsersAPI = {
  // -----------------------------
  // ADMIN
  // -----------------------------
  getAll: (): Promise<UserDto[]> =>
    api.get("/users").then((r) => r.data),

  getOne: (id: number): Promise<UserDto> =>
    api.get(`/users/${id}`).then((r) => r.data),

  create: (data: CreateUserDto): Promise<UserDto> =>
    api.post("/users", data).then((r) => r.data),

  update: (id: number, data: UpdateUserDto): Promise<UserDto> =>
    api.put(`/users/${id}`, data).then((r) => r.data),

  deactivate: (id: number): Promise<any> =>
    api.delete(`/users/${id}`).then((r) => r.data),

  reactivate: (id: number): Promise<any> =>
    api.post(`/users/${id}/reactivate`).then((r) => r.data),

  // -----------------------------
  // PROFILE (личный кабинет)
  // -----------------------------
  me: (): Promise<UserDto> =>
    api.get("/users/me").then((r) => r.data),

  updateMe: (data: UpdateUserDto): Promise<UserDto> =>
    api.put("/users/me", data).then((r) => r.data),

  changePassword: (oldPass: string, newPass: string): Promise<any> =>
    api.post("/users/change-password", { oldPass, newPass }).then((r) => r.data),

  uploadAvatar: (file: File): Promise<{ avatarUrl: string }> => {
    const form = new FormData();
    form.append("file", file);
    return api
      .post("/users/me/avatar", form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },
};
